import { render, staticRenderFns } from "./CardMinhaInscricao.vue?vue&type=template&id=3656bb95"
import script from "./CardMinhaInscricao.vue?vue&type=script&lang=js"
export * from "./CardMinhaInscricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports